(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bpb-recent-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    const notice = document.querySelector('[data-bpb-recent-purchase]');
    if (!notice) return;

    const image = notice.querySelector('img');
    if (image) {
      image.addEventListener('error', () => {
        const media = image.closest('.bpb-recent-purchase__media');
        if (media) media.remove();
        const link = notice.querySelector('.bpb-recent-purchase__link');
        if (link) link.style.gridTemplateColumns = 'minmax(0, 1fr)';
      });
    }

    const purchasedAt = Date.parse(notice.dataset.purchasedAt || '');
    const time = notice.querySelector('time');
    if (time && Number.isFinite(purchasedAt)) {
      const hours = Math.max(1, Math.floor((Date.now() - purchasedAt) / 3600000));
      const days = Math.floor(hours / 24);
      const template = hours < 24
        ? (hours === 1 ? notice.dataset.hourAgo : notice.dataset.hoursAgo)
        : (days === 1 ? notice.dataset.dayAgo : notice.dataset.daysAgo);
      time.textContent = template.replace('__COUNT__', hours < 24 ? hours : days);
    }

    const showTimer = window.setTimeout(() => {
      notice.hidden = false;
      window.requestAnimationFrame(() => notice.classList.add('is-visible'));
    }, 2500);

    const hideTimer = window.setTimeout(() => {
      notice.classList.remove('is-visible');
      window.setTimeout(() => {
        notice.hidden = true;
      }, 200);
    }, 12000);

    notice.querySelector('[data-bpb-recent-purchase-close]')?.addEventListener('click', () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
      notice.classList.remove('is-visible');
      window.setTimeout(() => {
        notice.hidden = true;
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
